import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InterfaceConfigComponent } from './interface-config.component';
import { InterfaceConfigService } from './interface-config.service';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    InterfaceConfigComponent
  ],
  providers: [
    InterfaceConfigService
  ],
  exports: [InterfaceConfigComponent],
})
export class InterfaceConfigModule { }



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/interface-config/interface-config.module.ts